import { getCodeList } from 'country-list';

export const countryList = (() => {
  const list = getCodeList();
  return Object.keys(list).map(el => ({
    name: list[el],
    value: el.toUpperCase(),
  }));
})();
